import { post } from "./index";

export const sendEmailService = (data) => {
  const request = {
    subUrl: `/email/send-email`,
    data,
  };
  return post(request);
}